import type { Matching, Nearby, VehicleType } from './types';

/**
 * The searching screen's numbers, from the ride's `matching` (polled every 3 s: how many drivers were offered the
 * ride, how many are still deciding) and `GET /v1/rider/nearby` (drivers of this type online around the pickup).
 * `empty`: nobody asked and nobody of this type online nearby — say so plainly instead of a hopeful bar.
 */
export function matchingView(m: Matching | null | undefined, nearby: Nearby | null, type: VehicleType) {
  const asked = Math.max(0, m?.asked ?? 0);
  const looking = Math.min(asked, Math.max(0, m?.looking ?? 0));
  const online = nearby?.types.find((x) => x.vehicleType === type)?.count ?? 0;
  return {
    asked,
    looking,
    offers: m?.offers ?? [],
    online,
    /** bar segments: at least 6 (the mockup's), one per driver asked, at most 10 drawn */
    segs: Math.min(10, Math.max(6, asked)),
    empty: asked === 0 && nearby != null && online === 0,
  };
}
